
export enum ReturnInstrRetainCheckCd {
	DEPARTMENT_OF_CLAIMS = 'DepartmentOfClaims'}

